module.exports = __webpack_public_path__ + "7a4c9c6f178cf70c420c64d69dbf6b37.svg";